import React from "react";
import {ItemData, ItemsDispatcher} from "./ItemsProviderDomain";

export const itemsDataInitialState:ItemData = {
    items: [],
    isLoading: false,
    itemsMessage: undefined
}

export let ItemsReducer: React.Reducer<ItemData, ItemsDispatcher> ;
ItemsReducer = ( itemsDataState:ItemData, action:ItemsDispatcher ) : ItemData => {
    //console.log(itemsDataState,  action )
    switch ( action.type ) {
        case "SUCCESS":
            return {
                items: ( action.payload !== undefined ) ? action.payload?.items : itemsDataState.items,
                isLoading: false,
                itemsMessage: undefined
            }

        case "REQUEST":
            return {
                ...itemsDataState,
                isLoading:true,
                itemsMessage:action.payload?.itemsMessage,
                itemsMessageVariant: action.payload?.itemsMessageVariant
            }

        case "ERROR":
            return {
                ...itemsDataState,
                isLoading: false,
                itemsMessage: action.error,
                itemsMessageVariant: "danger"
            }


        default:
            return itemsDataState
    }
}